import React, { PureComponent } from 'react'
import Typography from '@material-ui/core/Typography'
import FlexDataView, { FlexDataItem } from 'components/FlexDataView'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'

export class TextDetails extends PureComponent {
  static propTypes = {
    dealSheet: PropTypes.object
  }

  render = () => {
    const {dealSheet} = this.props
    return (
      <FlexDataView>
        <FlexDataItem size="medium">
          <Typography variant='subtitle1'>Description</Typography>
          <p className={styles.pre}>{dealSheet.description}</p>
        </FlexDataItem>
        <FlexDataItem size="medium">
          <Typography variant='subtitle1'>Problem being solved</Typography>
          <p className={styles.pre}>{dealSheet.problemBeingSolved}</p>
        </FlexDataItem>
        <FlexDataItem size="medium">
          <Typography variant='subtitle1'>Use of Funds</Typography>
          <p className={styles.pre}>{dealSheet.useOfFunds}</p>
        </FlexDataItem>
        <FlexDataItem size="medium">
          <Typography variant='subtitle1'>Risks</Typography>
          <p className={styles.pre}>{dealSheet.risks}</p>
        </FlexDataItem>
      </FlexDataView>
    )
  }
}

const styles = StyleSheet({
  pre: {
    whiteSpace: 'pre'
  }
})